import { useEffect } from 'react';

import { useLDClient } from 'launchdarkly-react-client-sdk';

import { UserEvents } from '~/analytics/userEvents';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import useLocalStorage from '~/lib/hooks/useLocalStorage';
import { loggedInEventTrackedKey, logInMethodKey } from '~/routes/constants';

const useSessionInit = (currentUser: GetProviderByIdResponse) => {
  const { trackEvent } = useAnalytics();
  const ldClient = useLDClient();
  const { storedValue: logInMethodValue } = useLocalStorage<string>(
    logInMethodKey,
    null,
  );

  useEffect(() => {
    if (currentUser && !sessionStorage.getItem(loggedInEventTrackedKey)) {
      const loginMethod = logInMethodValue || 'Unknown';
      trackEvent(UserEvents.loggedIn, {
        method: loginMethod,
      });
      sessionStorage.setItem(loggedInEventTrackedKey, 'true');
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      ldClient?.identify({
        kind: 'multi',
        organization: {
          key: 'equip-vesta',
        },
        user: {
          key: currentUser.userId,
          role: currentUser.providerTypeName,
        },
      });
    }
  }, [currentUser, currentUser?.userId, ldClient]);
};

export default useSessionInit;
